import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowProviderService {

  constructor() { }

  getHostname(): string {
    return window.location.hostname;
  }
}
